import { render } from "./ServiceListView.vue?vue&type=template&id=0dc945c6&scoped=true&ts=true"
import script from "./ServiceListView.vue?vue&type=script&lang=ts"
export * from "./ServiceListView.vue?vue&type=script&lang=ts"

import "./ServiceListView.vue?vue&type=style&index=0&id=0dc945c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc945c6"]])

export default __exports__